export class StrapiSiteSettingsDTO {
  constructor() {}

  legalName: string;
  telephone: string;
  mobile: string;
  email: string;
  addressStreet: string;
  addressLocality: string;
  addressPostalCode: string;
  workingHours: string;
  hoursOpens?: string;
  hoursCloses?: string;
  hoursDays?: string;
  bookAppointmentPrompt: string;
  googleMapsUrl: string;
  googleBusinessProfileUrl: string;
  googleWriteReviewUrl: string;
  eopyyContracted: boolean;
}

export class SiteSettingsDTO {
  constructor() {}

  extraData: any = {};
  legalName: string;
  telephone: string;
  mobile: string;
  email: string;
  addressStreet: string;
  addressLocality: string;
  addressPostalCode: string;
  workingHours: string;
  hoursOpens?: string;
  hoursCloses?: string;
  hoursDays?: string;
  bookAppointmentPrompt: string;
  googleMapsUrl: string;
  googleBusinessProfileUrl: string;
  googleWriteReviewUrl: string;
  eopyyContracted: boolean;
}
